import React from "react"
import {Body, H4} from "@irati/ui/src/Typography"
import FormattedMessage, {useIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import Button from "@irati/ui/src/Button"
import Spacing from "@irati/ui/src/Spacing"
import withBranding, {WithBranding} from "@irati/brand/withBranding"
import {BusinessLogo} from "../../containers/OneTimePassword/styled"

interface Props extends WithBranding {
  id?: string
  helpLinks?: JSX.Element[]
  hideTitle?: boolean
  onBack?: boolean
  showBrandingInHeader?: boolean
}

const LoginBlock: React.FC<Props> = (props) => {
  const {children, helpLinks, hideTitle = false, onBack, branding, showBrandingInHeader} = props
  const idNamespace = id("login-block", props)
  const {formatMessage} = useIntl()

  return (
    <div id={idNamespace}>
      {onBack && (
        <Flex marginBottom={3}>
          <Button tertiary onClick={onBack}>
            <Icon icon={IconTypes.angleLeft} marginRight />
            <FormattedMessage id="platform.back" />
          </Button>
        </Flex>
      )}
      {showBrandingInHeader && branding?.businessLogoUrl && (
        <Flex justifyContent="center" marginBottom={1}>
          <BusinessLogo src={formatMessage({id: branding?.businessLogoUrl})} />
        </Flex>
      )}
      {children}
      {helpLinks && (
        <Spacing marginTop={2}>
          {!hideTitle && (
            <H4 marginBottom={1}>
              <FormattedMessage id="platform.login.header.needHelp" />
            </H4>
          )}

          {helpLinks.map((helpLink, index) => (
            <Body small marginTop={0.5} key={index}>
              {helpLink}
            </Body>
          ))}
        </Spacing>
      )}
    </div>
  )
}

export default withBranding(LoginBlock)
